import React from 'react'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Explore, Error } from '@mui/icons-material'
import { LocationData } from 'services/location'

export interface IAddressSuggestionsProps {
  suggestions: LocationData[]
  changed: boolean
  loadingSuggestions: boolean
  locationSelected: boolean
  onSelectLocation: (e: React.MouseEvent<unknown>, suggestion: LocationData) => void
}

function AddressSuggestions(props: IAddressSuggestionsProps) {
  const { suggestions, changed, loadingSuggestions, locationSelected, onSelectLocation } = props

  if (loadingSuggestions) {
    return (
      <List dense>
        <ListItem data-cy="address-suggestion-loading">
          <ListItemIcon>
            <Error />
          </ListItemIcon>

          <ListItemText primary="Searching..." />
        </ListItem>
      </List>
    )
  }

  if (suggestions.length > 0) {
    return (
      <List dense>
        {suggestions.map((suggestion, index) => (
          <ListItemButton
            key={suggestion.id}
            onClick={e => onSelectLocation(e, suggestion)}
            data-cy={`address-suggestion-${index}`}
          >
            <ListItemIcon style={{ minWidth: 38 }}>
              <Explore />
            </ListItemIcon>

            <ListItemText primary={suggestion.placeName} secondary={index === 0 ? 'Best match, press ENTER to accept' : undefined} />
          </ListItemButton>
        ))}
      </List>
    )
  }

  if (changed && !locationSelected && !loadingSuggestions) {
    return (
      <List>
        <ListItem data-cy="address-suggestion-empty">
          <ListItemIcon>
            <Error />
          </ListItemIcon>

          <ListItemText
            primary="Address not found"
            secondary="We could not locate the address you entered. Try using a more generic address"
          />
        </ListItem>
      </List>
    )
  }
  return null
}

export default React.memo(AddressSuggestions)
